import { AbstractRouterFilter } from '@zk/framework-vue';

const replaceHashPath = (to) => {
  if (to.redirectedFrom?.substr(0, 2) === '/#') {
    return to.redirectedFrom.substr(2);
  }
  if (to.fullPath.substr(0, 2) === '/#') {
    return to.fullPath.substr(2);
  }
  if (to.fullPath.startsWith('/liga/')) {
    return to.fullPath.substring(6) || '/';
  }
  return null;
};

                 
const LEIGA_DISABLE_KEYWORDS = ['liga', 'overseas'];
        
                                           
         

export class SupportLegacyHashFilter extends AbstractRouterFilter {
  // 必须第一个执行
  order() {
    return -100;
  }

  onBefore(to) {
    const legacyPath = replaceHashPath(to);
    if (LEIGA_DISABLE_KEYWORDS.some((keyword) => to.path.includes(keyword) || legacyPath?.includes(keyword))) {
      window.console.warn(`disabled route ${to.fullPath}`);
      return { name: '404' };
    }
    if (legacyPath) {
      console.log(`legacy hash ${to.fullPath} to ${legacyPath}`);
      return legacyPath;
    }
    return true;
  }
}
